/* eslint import-x/no-duplicates: "off"
   --------
   @typescript-eslint/consistent-type-imports conflicts with this
   rule when only some imports are type-only from the same file. */
import type {TimeSeriesS} from '../fin/history.ts';
import {toCsv} from '../fin/history.ts';
import {save} from '../save_file.ts';

type MenuClickHandler = (ev: MouseEvent) => void;
type MenuItems = Map<string, MenuClickHandler>;

export function setContextMenuHandler(
  source: HTMLElement,
  data: TimeSeriesS<number>,
) {
  source.addEventListener(
    'contextmenu',
    (ev: MouseEvent) => {
      ev.preventDefault();
      console.log('context menu fired');
      const menu_items: MenuItems = new Map<string, MenuClickHandler>();

      menu_items.set(
        'save csv',
        async (_ev: MouseEvent) => {
          console.log('saving csv file');
          const csv = toCsv(data.data);
          await save(csv, 'fin_data.csv');
        },
      );

      showContextMenu(source, ev, menu_items);
    },
  );
}

function showContextMenu(_target: HTMLElement, event: MouseEvent, menu_items: MenuItems) {
  const MENU_CLASS = 'fin-context-menu';

  for (const predecessor of document.body.querySelectorAll(`.${MENU_CLASS}`)) {
    predecessor?.remove();
  }

  const mouseX: number = event.clientX;
  const mouseY: number = event.clientY;

  const menu = document.createElement('div');
  menu.setAttribute('class', 'fin-context-menu');
  document.body.append(menu);

  menu.innerHTML = `
    <ul class="fin-context-menu-items">
    </ul>
  `;

  menu.setAttribute(
    'style',
    'position: fixed; top: ' + mouseY + 'px; left: ' + mouseX + 'px;',
  );

  const menu_closer = function () {
    menu.remove();
  };

  const list = menu.querySelector('.fin-context-menu-items');

  for (const item of menu_items.entries()) {
    const item_elem = list!.ownerDocument.createElement('li');
    item_elem.innerHTML = item[0];

    const click_handler: MenuClickHandler = function (ev: MouseEvent) {
      const menu_item_handler = item[1];
      globalThis.setTimeout(menu_closer, 0);
      menu_item_handler(ev);
    };

    item_elem.addEventListener('click', click_handler);
    list!.append(item_elem);
  }

  const close_and_log = function (_ev: MouseEvent) {
    console.log('closing context menu without having selected a command');
    menu_closer();
  };

  document.body.addEventListener('click', close_and_log, { once: true });
}
